/*
 * @Author: bbqin
 * @Date: 2022-08-11 10:27:52
 * @LastEditTime: 2022-09-07 13:49:18
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\model\free.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as constant from '../const';
import ViewModel from '../../api/viewmodel';
import * as log from '../utils/log';
import React, { Fragment, isValidElement } from "react";
import { isPromise, getObjectType, isArray } from '../utils/type';

// 缓存的json
const FreeExtendCacheName = constant.freeExtendCacheName;
const AreaConfigDefaultName = constant.areaConfigDefaultName;

// 空方法
const EmptyFunction = constant.emptyFunction;
// preventEvent cache name
const PreventEventCacheName = constant.preventEvent;
// defaultLayer
const DefaultLayer = constant.defaultLayer;

/**
 * 获取vm
 * @returns 
 */
const getViewModel = function () {
    const vm = ViewModel || window?.ViewModel;
    if (!vm) {
        log.error(vm, 'viewModel没有找到,可能会导致全局属性取不到');
    }
    return vm || {};
};

/**
 * 启用阻止事件
 * @param {*} path 
 */
export const preventEvent = function (path) {
    path = isArray(path) ? path.join() : path;
    const vm = getViewModel();
    const pe = vm.getData(PreventEventCacheName) || {};
    pe[path] = true;
    vm.setData(PreventEventCacheName, pe);
};

/**
 * 阻止默认
 * @param {*} path 
 */
export const preventDefault = function (moduleId, eventName) {
    const path = [DefaultLayer, moduleId, eventName].join();
    const vm = getViewModel();
    const pe = vm.getData(PreventEventCacheName) || {};
    pe[path] = true;
    vm.setData(PreventEventCacheName, pe);
};

/**
 * 获取阻止事件
 * @param {*} path 
 */
export const getPreventEvent = function (path) {
    path = isArray(path) ? path.join() : path;
    const vm = getViewModel();
    const pe = vm.getData(PreventEventCacheName) || {};
    return pe[path];
};

/**
 * 清理
 */
export const cleanPreventEvent = function (moduleId, eventName, attrcode) {
    const vm = getViewModel();
    const defaultStr = [DefaultLayer, moduleId, eventName].join();
    const layerStr = [moduleId, eventName, attrcode].join();
    const pe = vm.getData(PreventEventCacheName) || {};
    for (let key in pe) {
        if (key === defaultStr || key.includes(layerStr)) {
            delete pe[key];
        }
    }
    vm.setData(PreventEventCacheName, pe);
};

/**
 * ViewModel 循环依赖模块会变为undefined 然后导致报错
 * 获取存储的客开配置json
 * @returns 
 */
export const getCacheExtendJson = function () {
    return (getViewModel()['getData'] || EmptyFunction)(FreeExtendCacheName);
};

/**
 * 获取某个路径挂再window上的所有方法
 * @param {*} modulePath 
 * @param {*} moduleName 
 * @returns 
 */
export const getModuleExports = function (modulePath, moduleName) {
    let methods = {};

    if ((getObjectType(window[modulePath]) === 'Object' || getObjectType(window[modulePath]) === 'Module') && Object.keys(window[modulePath]).length) {
        methods = Object.assign(methods, window[modulePath][moduleName] || {}, window[modulePath], window[modulePath].default || {});
    } else if (getObjectType(window[moduleName]) === 'Object') {
        // 客开注册对象挂在window[moduleName]  moduleName 默认是 NCCExtend
        methods = window[moduleName];
    }

    return methods;
};

/**
 * 把所有层的方法按照对象方式放置
 * @param {*} layers 
 * @param {*} scope 
 * @returns 
 */
const getLayersMethodsObj = function (layers, scope) {
    let layersMethods = {};
    for (const alias in layers) {
        if (Object.hasOwnProperty.call(layers, alias)) {
            const element = layers[alias];
            let allMethods = getModuleExports(element, alias);
            // 备用取值方案
            if (!Object.keys(allMethods).length) {
                log.blue(`取存再createPage上的备用加载对象`);
                allMethods = (scope?.fastExtend?.moduleExports || {})[alias] || {};
            }

            layersMethods[alias] = allMethods;
        }
    }

    return layersMethods;
};

// 目前不处理结果的事件
const unknownResultEvents = ['afterMetaUpdate', 'beforeMetaUpdate', 'beforeUnMountEvent', 'currentPageDidMount', 'templateAlreadyLoaded', 'UIExtend'];
/**
 * 根据事件名称获取 返回结果
 * @param {*} results 
 * @param {*} prevResult 
 * @param {*} eventName 
 */
function getPageEventResult(results = [], prevResult, eventName) {
    // 默认是最后一次的结果
    let result = prevResult;

    if (unknownResultEvents.includes(eventName)) {
        return result;
    }

    switch (eventName) {
        case 'pageRenderExtend':
        case 'localExtendRouter':
            // 返回的是dom类型  统一执行dom对象
            result = <Fragment>
                {results.map(item => item)}
            </Fragment>;
            break;
        case 'beforeTriggerCreate':
            let arrayCount = 0;
            let objCount = 0;
            results.forEach(item => {
                if (getObjectType(item) === 'Array') {
                    arrayCount++;
                } else if (getObjectType(item) === 'Object') {
                    objCount++;
                }
            });
            // 如果某一层返回数组类型 其他层都认为是数组
            if (arrayCount > 0 && objCount === 0) {
                // beforeTriggerCreate
                result = results.reduce((previousValue = [], currentValue = []) => { return Object.assign(previousValue, currentValue); }, []);
            } else if (objCount > 0) {
                result = results.reduce((previousValue = {}, currentValue = {}) => { return { ...previousValue, ...currentValue }; }, {});
            }
            break;
        case 'beforeAjaxSend':
        case 'dataAlreadyLoaded':
            result = prevResult;
            break;
        default:
            break;
    }

    return result;
}

/**
 * 是否是默认层
 * @param {*} layer 
 * @returns 
 */
const isDefaultLayer = function (layer) {
    return !layer || layer === DefaultLayer;
};

/**
 * 解析json
 * @param {*} freeExtendCacheJson 
 * @param {*} name 
 * @param {*} scope 
 * @param  {...any} params 
 * @returns 
 */
export const analysisPageEventExtend = function (freeExtendCacheJson, name, scope, defaultf, ...params) {
    let { layers = [], path = [], page = {} } = freeExtendCacheJson;

    let config = page[name] || [];

    if (!config.length) {
        // beforeTriggerCreate 提示太频繁，隔离
        name !== 'beforeTriggerCreate' && log.orange(`未找到${name}的客开配置`);
        return (defaultf || EmptyFunction)(...params);
    }

    log.blue(`执行${name}的客开方法`);

    // 先整理事件对象
    // let layersMethods = getLayersMethodsObj(path, scope);

    // 前一次的运行结果
    let results = [];
    let prevResult = EmptyFunction(...params);
    // 数组顺序就是执行顺序
    config.forEach(item => {
        let { layer = '', enable = true, description, method } = item;
        if (enable === false) {
            return;
        }
        if (layer && method) {
            // 处理异步的情况
            if (isPromise(prevResult)) {
                prevResult = prevResult.then(() => {
                    return method(...params);
                }).then(res => {
                    results.push(res);
                    return results;
                });
            } else {
                prevResult = method(...params);
                // 如果中间有一层是异步  则再次之后的事件都变为异步
                if (isPromise(prevResult)) {
                    prevResult = Promise.resolve(prevResult).then(res => {
                        results.push(res);
                        return results;
                    });
                } else {
                    results.push(prevResult);
                }
            }
        } else {
            log.error(false, '未找到客开的事件', layer, method, name, config);
        }
    });

    // 判断数据类型  然后处理数据 
    return getPageEventResult(results, prevResult, name);
};

/**
 * 根据事件名称获取 返回结果
 * @param {*} results 
 * @param {*} prevResult 
 * @param {*} eventName 
 */
function getComponentEventResult(results = [], prevResult, eventName) {
    // 默认是最后一次的结果
    let result = prevResult;

    switch (eventName) {
        default:
            let type = getObjectType(prevResult);
            // 默认类型的判断
            if (isValidElement(prevResult)) {
                result = <Fragment>
                    {results.map(item => item)}
                </Fragment>;
            } else if (type === 'Array') {
                result = results.reduce((previousValue = [], currentValue = []) => { return Object.assign(previousValue, currentValue); }, []);
            } else if (type === 'Object') {
                result = results.reduce((previousValue = {}, currentValue = {}) => { return { ...previousValue, ...currentValue }; }, {});
            } else if (type === 'Boolean') {
                // 布尔型 取最后一次的
                result = prevResult;
            } else {
                result = prevResult;
            }
            break;
    }

    return result;
}

/**
 * 解析组件级的客开事件
 * @param {*} freeExtendCacheJson 
 * @param {*} config 
 * @param {*} name 
 * @param {*} params 
 * @param {Function} defaultf 领域的方法
 * @returns 
 */
export const analysisComponentEventExtend = function (freeExtendCacheJson, params, defaultFunction = EmptyFunction) {
    let { component = {} } = freeExtendCacheJson;

    let { attrcode = '', moduleId = '', fxType, fxParams = {} } = params;

    if (!moduleId) {
        return defaultFunction();
    }

    // 参数转换
    fxParams = isArray(fxParams) ? fxParams : [fxParams];

    // 区域下的配置项 例如  component:{onBtnClick: []};component:{onBtnClick: {attrcode: []}}
    let areaConfig = (component[moduleId] || {})[fxType] || {};

    // 字段级config
    let config = [];

    if (isArray(areaConfig)) {
        config = areaConfig;
    } else {
        config = areaConfig[attrcode] || [];
        // module中合并过来的配置项
        let deaultConfig = areaConfig[AreaConfigDefaultName] || [];
        // 如果只有 deaultConfig 则 config 等于
        if (deaultConfig.length && Object.keys(areaConfig).length === 1) {
            config = deaultConfig;
        }
    }

    if (!config.length) {
        log.orange(`未找到${fxType}的客开配置`, component);
        return defaultFunction();
    }

    log.blue(`执行${fxType}的客开方法`);

    // 先整理事件对象 所有层的 客开方法
    // let layersMethods = getLayersMethodsObj(path, scope);

    // 前一次的运行结果
    let results = [];
    let hasDefault = config.find(item => {
        let { layer = '' } = item;
        return isDefaultLayer(layer);
    });

    cleanPreventEvent(moduleId, fxType, attrcode);

    // 如果没有默认领域事件，则领域事件优先执行，否则在顺序里执行
    let prevResult = !hasDefault ? defaultFunction() : EmptyFunction();

    // 数组顺序就是执行顺序
    config.forEach((item, index) => {
        let { layer = '', enable = true, method } = item;

        // 某一层  扩展开发的  所有方法
        let isDefault = isDefaultLayer(layer);

        // 默认事件被阻止了
        if (isDefault) {
            let isPrevent = getPreventEvent([DefaultLayer, moduleId, fxType]);
            if (isPrevent) {
                return;
            }
        }

        let func = isDefault ? defaultFunction : method;
        if (func) {

            // 不执行某个方法  不放在上面的原因是因为 避免方法没有  导致基础事件都不执行了
            if (enable === false) {
                return;
            }

            // 处理异步的情况
            if (isPromise(prevResult)) {
                prevResult = prevResult.then(() => {
                    let isPrevent = getPreventEvent([layer, moduleId, fxType, attrcode]);
                    return isPrevent ? prevResult : func(...fxParams);
                }).then(res => {
                    // results.push(res);
                    // 解决如果是异步（onBeforeEvent） 取到的数据是数组
                    return res;
                });
            } else {
                let isPrevent = getPreventEvent([layer, moduleId, fxType, attrcode]);
                prevResult = isPrevent ? prevResult : func(...fxParams);
                // 如果中间有一层是异步  则再次之后的事件都变为异步
                if (isPromise(prevResult)) {
                    prevResult = Promise.resolve(prevResult).then(res => {
                        // results.push(res);
                        // 解决如果是异步（onBeforeEvent） 取到的数据是数组
                        return res;
                    });
                } else {
                    results.push(prevResult);
                }
            }
        } else {
            log.error(false, '未找到客开的事件', layer, method, func, fxType, config);
        }
    });

    return getComponentEventResult(results, prevResult, fxType);
};